import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { endpoints, fetcher } from 'services';
import { INIT_PAGESIZE } from 'commons/constants';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

const useMyPmlProject = (page: string, userid: string) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [pmlList, setPmlList] = useState<B2cPmlListDto[]>();
  const [searchResult, setSearchResult] = useState({ pageNo: 0, pageSize: INIT_PAGESIZE, totalCount: 0 });

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();
  const searchParams = qs.parse(location.search);
  const { isLoading, refetch } = useQuery(
    [endpoints.mypage.pml1, [location.search, userid, page]],
    () =>
      fetcher.mypage.postPmlProjectList1({
        pageNo: Number(searchParams.pageNo) || 1,
        pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
        pm: String(userid),  
        group: String(page),  
      }),
    {
      enabled: (page === 'pml1' || page === 'pml2' || page === 'pml3'), 
      onSuccess: (res: CommonSearchListResDto) => {
        switch (res.code) {
          case 200:
            setPmlList(res.result?.list);
            setSearchResult({
              pageNo: res.result?.pageNo || 1,
              pageSize: res.result?.pageSize || INIT_PAGESIZE,
              totalCount: res.result?.totalCount || 0,
            });
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { pmlList, searchResult, refetch };
};

export default useMyPmlProject;
